import { useRef, useState } from 'react';
import { Button, TooltipProps } from 'lego-on-react';
import { selectTextContent } from '../utils';

export const useCopy = () => {
    const textRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<Button>(null);

    const [tooltipVisible, setTooltipVisibility] = useState(false);

    const onCodeClick = () => {
        const selection = window.getSelection()!;

        if (selection.anchorOffset !== selection.focusOffset || selection.anchorNode !== selection.focusNode) {
            return;
        }

        selectTextContent(textRef.current!);
    };

    const onButtonClick = () => {
        selectTextContent(textRef.current!);
        document.execCommand('copy');
        setTooltipVisibility(true);
    };

    const getTooltipProps = (): TooltipProps => ({
        visible: tooltipVisible,
        anchor: buttonRef.current!,
        onOutsideClick: () => setTooltipVisibility(false),
    });

    return { getTooltipProps, onCodeClick, onButtonClick, textRef, buttonRef };
};
